import React, { Component } from 'react';

export class AsyncFilterContainer extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.props.onMount();
    }

    render() {
        if (this.props.check() == null)  return this.props.placeholder
        if (this.props.check()) return this.props.children;
        else return null
    }
};